import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import * as R from 'ramda';
import { FieldCondition } from '@wdx/shared/swagger-gen';

@Injectable({ providedIn: 'root' })
export class FieldConditionService {
    public conditionTrue(
        condition: FieldCondition,
        value: any | any[],
        index?: number,
    ): boolean {
        value = R.isNotNil(index) ? value[index] : value;
        if (condition?.empty && (R.isNil(value) || R.isEmpty(value))) {
            return true;
        }
        if (condition?.notEmpty && R.isNotNil(value) && R.isNotEmpty(value)) {
            return true;
        }
        if (condition?.anyOf?.length && condition.anyOf.includes(value)) {
            return true;
        }
        if (R.isNotNil(condition?.equalTo) && condition.equalTo === value) {
            return true;
        }
        if (
            condition?.greaterThan &&
            typeof value === 'number' &&
            value > condition.greaterThan
        ) {
            return true;
        }
        if (
            condition?.lesserThan &&
            typeof value === 'number' &&
            value < condition.lesserThan
        ) {
            return true;
        }

        if (R.isNotNil(condition?.future) || R.isNotNil(condition?.past)) {
            const dt = DateTime.fromISO(value as string);
            if (!dt.isValid) {
                return false;
            }
            const isFuture =
                (R.isNotNil(condition?.future) && condition.future) ||
                (R.isNotNil(condition?.past) && !condition.past);
            const isPast =
                (R.isNotNil(condition?.past) && condition.past) ||
                (R.isNotNil(condition?.future) && !condition.future);
            if (isFuture === isPast) {
                console.log(
                    'Bad form config, future and past condition values are not compatible',
                    condition,
                );
            }
            return isFuture ? dt > DateTime.now() : dt < DateTime.now();
        }
        return false;
    }
}
